/**
 * @description: 路由对应展示内容
 */
export enum MenuItem {
  Home = 'Home',
  ScheduleManage = 'ScheduleManage',
  CaseManage = 'CaseManage',
  DocumentManage = 'DocumentManage'
}

/**
 * @description: 法庭类型
 */
export enum tribunalType {
  default = 'default',
  arbitration = 'arbitration'
}

/**
 * @description: 庭审人员身份信息
 */
export enum trialRoleType {
  arbitrators = 'arbitrators',
  arbitrators_fusion = 'arbitrators_fusion',
  judge = 'judge',
  judge_fusion = 'judge_fusion',
  clerk = 'clerk',
  clerk_fusion = 'clerk_fusion',
  party = 'party',
  procurator = 'procurator',
  defendant = 'defendant',
  plaintiff = 'plaintiff',
  pagent = 'pagent',
  dagent = 'dagent',
  third = 'third',
  evidence = 'evidence'
}

/**
 * @description: 庭审人员身份展示信息
 */
export const trialRole = {
  [trialRoleType.arbitrators]: '首席仲裁员',
  [trialRoleType.arbitrators_fusion]: '首席仲裁员',
  [trialRoleType.judge]: '审判长',
  [trialRoleType.judge_fusion]: '审判长',
  [trialRoleType.clerk]: '书记员',
  [trialRoleType.clerk_fusion]: '书记员',
  [trialRoleType.party]: '当事人',
  [trialRoleType.procurator]: '代理人',
  [trialRoleType.defendant]: '被告',
  [trialRoleType.plaintiff]: '原告',
  [trialRoleType.pagent]: '原告代理人',
  [trialRoleType.dagent]: '被告代理人',
  [trialRoleType.third]: '第三人',
  [trialRoleType.evidence]: '示证画面'
}

/**
 * @description: 庭审状态
 */
export enum trialStatus {
  // 未开庭
  unTrial = 'unTrial',
  // 预备开庭
  preparing = 'preparing',
  // 庭审中
  trialing = 'trialing',
  // 休庭中
  // adjourned = 'adjourned',
  adjourned = 'adjourning',
  // 已闭庭
  trialed = 'trialed',
  // 已归档
  filed = 'filed'
}

export const trialStatusText = {
  // 未开庭
  [trialStatus.unTrial]: '未开庭',
  // 预备开庭
  [trialStatus.preparing]: '预备开庭',
  // 庭审中
  [trialStatus.trialing]: '庭审中',
  // 休庭中
  [trialStatus.adjourned]: '休庭中',
  // 已闭庭
  [trialStatus.trialed]: '已闭庭',
  // 已归档
  [trialStatus.filed]: '已归档'
}

/**
 * @description: 会议状态
 */
export enum meetingStatus {
  // 未创建
  unCreate = 'unCreate',
  // 会议中
  open = 'open',
  // 关闭
  closed = 'closed'
}

/**
 * @description: 庭审页面中按钮、展示区域控制字段及内容数组
 */
export const trailControlButtonsArr = [
  {
    value: 'member',
    label: '成员'
  },
  {
    value: 'evidence',
    label: '证据材料'
  },
  {
    value: 'written',
    label: '文字交流'
  },
  {
    value: 'note',
    label: '笔录'
  }
]

/**
 * @description: 庭审页面中按钮、展示区域控制字段及内容
 */
export const trailControlButtons = {
  member: '成员',
  evidence: '证据材料',
  written: '文字交流',
  note: '笔录'
}

/**
 * @description: 【笔录】上传文件格式白名单
 */
export const noteAccept = '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';

/**
 * @description: 【证据】上传文件文件格式白名单
 */
export const evidenceAccept = [
  // 接受所有声音文件
  'audio/*',
  // 接受所有视频文件
  'video/*',
  // 接受所有图像文件
  'image/*',
  // *.txt
  'text/plain',
  // *.doc
  'application/msword',
  // *.pdf
  'application/pdf',
  // *.wps
  'application/vnd.ms-works',
  // *.zip
  'application/zip',
  // *.rar
  'application/rar',
  // *.xls
  'application/vnd.ms-excel',
  // .xlsx
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  // .pptx
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  // .docx
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
].join(',')

/**
 * @description: 【个人资料】上传头像文件格式白名单
 */
export const iconAccept = 'image/*'

/**
 * @description: 【证据】展示图标文件类型
 */
export enum evidenceFileType {
  doc = 'doc,docx',
  pdf = 'pdf',
  image = 'png,jpg,jpeg,bmp,tif,gif,svg,psd,ai,raw,WMF,webp',
  mp4 = 'mp4,MP4,wmv,asf,asx,rm,rmvb,mov,m4v,3gp,mp3,MP3,MPEG,WMA',
  rar = 'rar,zip'
}

/**
 * @description: 【证据】定义证据状态
 */
export enum evidenceUploadStatus {
  fail = 'fail',
  success = 'success',
  uploading = 'uploading',
  uploadCloud = 'uploadCloud',
  ready = 'ready'
}

/**
 * @description: 【证据】定义证据状态文字描述
 */
export const evidenceUploadStatusText = {
  [evidenceUploadStatus.fail]: '上传失败',
  [evidenceUploadStatus.success]: '上传成功',
  [evidenceUploadStatus.uploading]: '上传中',
  [evidenceUploadStatus.uploadCloud]: '上云中',
  [evidenceUploadStatus.ready]: '上传中',
}

/**
 * @description: 【视频】码流类型
 */
export enum streamType {
  main = 0,
  sub = 1
}

/**
 * @description: 【视频】通道类型
 */
// 通道类型: 0 - 默认; 1 - IPC; 2 - 模拟通道; 3 - 导播; 4 - 课件
export enum channelType {
  judge = 3,
  evidence = 4
}
